module.exports = __webpack_public_path__ + "img/sesuboard-hw.129ac17c.jpg";